import { HubConnectionBuilder, HttpTransportType, LogLevel, type HubConnection } from '@microsoft/signalr';
import { runtimeConfig } from '@/app/config/runtimeConfig';
import { getAccessToken, getConnectionId, getSessionId, refreshAccessToken } from '@/shared/api/http/tokenProvider';

/** DAL hub bağlantısı: JWT accessTokenFactory + kiracı/oturum query'si; WebSocket → LongPolling fallback. */
export function createHub(path: '/systemhub' | '/messagehub' | '/loghub', extraQuery: Record<string, string> = {}): HubConnection {
  const q = new URLSearchParams(extraQuery);
  const conn = getConnectionId();
  if (conn) q.set('connection', conn);
  const sid = getSessionId();
  if (sid) q.set('sessionId', sid);
  const url = `${runtimeConfig().dalUrl}${path}${q.toString() ? `?${q}` : ''}`;
  return new HubConnectionBuilder()
    .withUrl(url, {
      accessTokenFactory: async () => getAccessToken() ?? (await refreshAccessToken()) ?? '',
      transport: HttpTransportType.WebSockets | HttpTransportType.LongPolling,
      withCredentials: false,
    })
    .withAutomaticReconnect([0, 2000, 5000, 10000, 30000])
    .configureLogging(LogLevel.Warning)
    .build();
}
